import { ActionParams } from '@ps/workbench/undo-redo/action-history'
import store from '@ps/store'

/**
 * 历史记录函数，所有需要处理历史记录的都必须使用该模块调用
 * @param action workspace/actionHistory/execute 的 action 参数
 * @param record 是否需要历史记录
 */
export function executeAction<T>({
  action,
  record = true,
}: {
  action: ActionParams
  record: boolean
}): Promise<T> {
  if (record) {
    return store.dispatch('workspace/actionHistory/execute', action)
  }

  return new Promise((resolve, reject) => {
    // 异步
    if (action.async) {
      action
        .execute(action.value)
        .then((res: T) => {
          resolve(res)
        })
        .catch((err: Error) => {
          console.log(err.message)
          reject(err)
        })
    } else {
      resolve(action.execute(action.value))
    }
  })
}
